import React, { useState, useContext, useCallback } from "react";
import { numberWithCommas } from "../../utils/application-helper";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import useRazorpay from "react-razorpay";
import { errorResponseMessage } from "../shared/const.prop";

const SubscriptionPayment = ({ data }) => {
  const appContext = useContext(AppContext);
  const [Razorpay] = useRazorpay();
  const [isValid, setIsValid] = useState(false);
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [coupon, setCoupon] = useState("");

  const checkCoupon = async () => {
    try {
      let payload = {
        coupon_code: coupon,
        plan_price: data?.price,
      };
      const isValidCoupon = await axiosHttp.post(`check-coupon`, {
        ...payload,
      });
      if (isValidCoupon.status === 200) {
        setDiscountedPrice(isValidCoupon?.data?.discounted_price);
        localStorage.setItem("discount", isValidCoupon?.data?.discounted_price);
        localStorage.setItem("coupon", coupon);
        setIsValid(true);
        appContext.updateNotificationState({
          show: true,
          message: isValidCoupon?.data?.message,
          type: "success",
        });
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const submitHandler = async () => {
    try {
      let payload = {
        mainPlanId: data?.main_plan_id,
        subPlanId: data?._id,
        couponCode: coupon,
        price: discountedPrice === "" ? `${data?.price}` : `${discountedPrice}`,
      };
      const checkSubscription = await axiosHttp.post(
        `subscription/create-order`,
        {
          ...payload,
        }
      );
      if (checkSubscription.status === 200) {
        const data = checkSubscription?.data;
        handlePayment(data);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const handlePayment = useCallback(
    (payload) => {
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: Number(payload?.amount) * 100,
        currency: payload?.currency,
        name: "Linkaa",
        description: "Premium Subscription",
        theme: {
          color: "#F37254",
        },
        handler: function (response) {
          if (response?.razorpay_payment_id) {
            let paymentId = response.razorpay_payment_id;
            handleCallbackPayment(payload, paymentId, coupon, discountedPrice);
          }
        },
        modal: {
          ondismiss: function () {
            // toast.error("Payment was cancelled");
            appContext.updateNotificationState({
              show: true,
              message: "Payment was cancelled",
              type: "error",
            });
            setPayLoader(false);
          },
        },
      };
      const rzpay = new Razorpay(options);

      rzpay.open();
      rzpay.on("payment.failed", function (response) {
        appContext.updateNotificationState({
          show: true,
          message: response.error.screen,
          type: "error",
        });
      });
    },
    [Razorpay]
  );

  const handleCallbackPayment = async (values, paymentId) => {
    let payload = {
      order_id: values?.order_id,
      payment_id: paymentId,
      coupon_code: localStorage.getItem("coupon")
        ? localStorage.getItem("coupon")
        : "",
      main_plan_id: data?.main_plan_id,
      sub_plan_id: data?._id,
      gross_price: `${data?.price}`,
      net_price: localStorage.getItem("discount")
        ? localStorage.getItem("discount")
        : data?.price,
    };
    try {
      const getPayment = await axiosHttp.post("subscription/verify-payment", {
        ...payload,
      });
      if (getPayment.status === 200) {
        appContext.updateModalState();
        localStorage.removeItem("coupon");
        localStorage.removeItem("discount");
        window.location.reload();
      } else {
        appContext.updateModalState();
        appContext.updateNotificationState({
          show: true,
          message: "Payment failed, please try again later",
          type: "error",
        });
      }
    } catch (error) {
      appContext.updateModalState();
      appContext.updateNotificationState({
        show: true,
        message: "Payment failed, please try again later",
        type: "error",
      });
    }
  };

  return (
    <div className="subscription-modal">
      <div className="card-body modal-body">
        <table className="ml-3">
          <tr className="">
            <td className="table-title mb-3">Gross Price</td>
            <td className="table-des">₹ {numberWithCommas(data?.price)}</td>
          </tr>
          <tr className="">
            <td className="table-title mb-3">Coupon Code</td>
            <td className="table-des">
              <div className="coupon-code">
                <div class="input-group">
                  <input
                    type="text"
                    className="input"
                    id="coupon"
                    name="coupon"
                    autocomplete="off"
                    onChange={(e) => setCoupon(e.target.value)}
                  />
                  <button className="button--submit" onClick={checkCoupon}>
                    Apply
                  </button>
                </div>
                {isValid && <span>Coupon Applied</span>}
              </div>
            </td>
          </tr>
          {discountedPrice !== "" && (
            <tr className="">
              <td className="table-title mb-3">Final Price</td>
              <td className="table-des">
                ₹ {numberWithCommas(discountedPrice)}
              </td>
            </tr>
          )}
        </table>
      </div>
      <div className="modal-footer">
        <button className="btn btn-primary mt-4" onClick={submitHandler}>
          Pay Now
        </button>
      </div>
    </div>
  );
};

export default SubscriptionPayment;
